module.exports = __webpack_public_path__ + "media/brands/scania-b4c5559e.png";